import { Link } from '@tanstack/react-router'
import { useEffect } from 'react'

import { useGetClientMarketFundamentals } from '@/gen/marketDataApi'
import { useGetClientMarket } from '@/gen/publicApi'

import { Card, CardContent } from '@/components/card'
import MarketStateCircle from '@/components/marketStateCircle'

import { useClearRecentMarket } from '@/state/recentMarkets'

interface Props {
    clientCode: string
    marketCode: string
}

export default function RecentMarketPanel({ clientCode, marketCode }: Props) {
    const market = useGetClientMarket(clientCode, marketCode)
    const marketFundamentals = useGetClientMarketFundamentals(clientCode, marketCode)
    const clearRecentMarket = useClearRecentMarket()
    useEffect(() => {
        if (market.isError) {
            clearRecentMarket(clientCode, marketCode)
        }
    }, [clientCode, marketCode, market.isError, clearRecentMarket])

    if (!market.data || market.isLoading || market.isError) {
        return null
    }

    const lastTimingEvent = marketFundamentals?.data?.lastTimingEvent || 'Open'
    const effectiveState = marketFundamentals?.data?.effectiveState || 'Open'

    return (
        <Card className="flex items-center h-20 overflow-hidden">
            <Link
                className="block w-full h-full"
                to="/$client_code/markets/$market_code"
                params={{ market_code: marketCode, client_code: clientCode }}
            >
                <CardContent className="h-full pt-6 hover:bg-muted/50">
                    <div className="flex items-center">
                        <MarketStateCircle
                            state={market.data.state}
                            lastTimingEvent={lastTimingEvent}
                            effectiveState={effectiveState}
                            className="mr-2"
                        />
                        <h4>{market.data.name}</h4>
                    </div>
                </CardContent>
            </Link>
        </Card>
    )
}
